export default class User {
    constructor(
        public cedula?: string,
        public codCuenta?: string,
		public password?: string,
        public primerNombre?: string,
        public segundoNombre?: string,
        public primerApellido?: string,
        public segundoApellido?: string,
        public correoElectronico1?: string,
        public correoElectronico2?: string,
        public celular?: string,
        public telefonoResidencia?: string,
        public otroTelefono?: string,
        public domicilio?: string,
        public edificio?: string,
        public apto?: string,
        public codSector?: string,
        public codCiudad?: string,
        public viaNotifi?: string,
        public parentesco?: string,
        public saldoCCI?: number,
        public monSalarioRetiro? : number,
        public esAfiliado?: boolean,
        public esAfiliadoFallecido?: boolean,
        public esAfiInactivo?: boolean,
        public fechaNacimiento?: string,
        public TokenGenerate?: string,
        public token?: string,
        public userIdentityEncrypt?: string,
        public fechaNacimientoDate?: string,
    ) {}

    public getNombres(): string {
        return (this.primerNombre.trim() +
            " " +
            (this.segundoNombre ? this.segundoNombre.trim() : "")).trim();
    }

    public getApellidos(): string {
        return (this.primerApellido.trim() +
            " " +
            (this.segundoApellido ? this.segundoApellido.trim() : "")).trim();
    }

    public getNombreCompleto(): string {
        return (this.getNombres() + " " + this.getApellidos()).trim();
    }
    public getToken(): string | undefined {
        return this.TokenGenerate;
      }    
      
      public getUserIdentity(): string | undefined {
        return this.cedula;
      }
    
    
      public getUserIdentityEncrypt(): string | undefined {
        return this.userIdentityEncrypt;
      }
}